import React, { useState, useEffect } from "react";
import { fetchProfileData } from "../utils/constants";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { updateProfileData } from "./updateProfileData";
import ProfilePhotoUploader from "./ProfilePhotoUploader";
import { sendEmailVerificationEmail } from "../Authentication/sendEmailVerificationEmail";
import { ToastContainer } from "react-toastify";
import { sendPasswordResetCall } from "../Authentication/sendPasswordResetEmail";
import GuestUserPage from "../utils/GuestUserPage";
import DefaultDP from "../../assets/images/defaultpp.png";
import Toast from "../Toast/Toast";
import Header from "../Header/Header";
// import SecondNavbar from "../Header/SecondNavbar";
import Footer from "../Footer/Footer";
import {
  Paper,
  Typography,
  Button,
  Grid,
  TextField,
  styled,
  Box,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import textProperties from "../utils/textProperties";
import {
  isMobileNumberValid,
  isEmailValid,
  isNameValid,
  isNumber,
  isPanNumberValid,
  isGSTNumberValid,
  isCompanyEmailValid,
  isValidIndianPhoneNumber,
} from "../utils/checks";
import "./styles.css";

const RootPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: "10px",
  border: "1px solid #ea5355",
  width: "80%",
  margin: "auto",
}));

const EditButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#ea5355",
  color: "white",
  marginTop: theme.spacing(2),
}));

// Toast("profilepage")

const ProfilePage = () => {
  const [user, setUser] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [profileData, setProfileData] = useState();
  const [verificationEmailSent, setVerificationEmailSent] = useState(false);
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // const handlePasswordChangeClick = () => {
  //   setShowPasswordChange(!showPasswordChange);
  // };

  const handleEmailVerificationClick = () => {
    sendEmailVerificationEmail();
    setVerificationEmailSent(true);
  };

  useEffect(() => {
    const auth = getAuth();
    // console.log(auth.currentUser);
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // console.log(user);
          let apiUrl = fetchProfileData;
          // const refreshedUser = await user.getIdToken(/* forceRefresh */ true);
          const refreshedUser = await user.getIdToken();
          const headers = {
            Authorization: `Bearer ${refreshedUser}`,
          };
          const response = await fetch(apiUrl, {
            method: "GET",
            headers,
          });

          if (!response.ok) {
            throw new Error("Failed to fetch data");
          }

          const { data } = await response.json();
          setProfileData(data);
          setProfilePic(data?.profilePic);
          console.log(data);
          // ...
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  const [addProfileData, setAddProfileData] = useState({
    role: "",
    firstName: "",
    lastName: "",
    mobileNumber: "",
    email: "",
    companyName: "",
    gstNumber: "",
    panNumber: "",
    companyAddress: "",
    companyEmail: "",
    phoneNumber: "",
  });

  useEffect(() => {
    if (profileData) {
      setAddProfileData({
        role: profileData.role || "",
        firstName: profileData.firstName || "",
        lastName: profileData.lastName || "",
        mobileNumber: profileData.mobileNumber || "",
        email: profileData.email || "",
        companyName: profileData.companyName || "",
        gstNumber: profileData.gstNumber || "",
        panNumber: profileData.panNumber || "",
        companyAddress: profileData.companyAddress || "",
        companyEmail: profileData.companyEmail || "",
        phoneNumber: profileData.phoneNumber || "",
      });
    }
  }, [profileData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddProfileData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveChanges = () => {
    updateProfileData(addProfileData);
  };

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (authUser) => {
      setUser(authUser);
    });

    return () => unsubscribe();
  }, []);

  function emailPasswordResetCall() {
    sendPasswordResetCall(profileData.email);
  }

  // console.log(user);
  return (
    <div className="profile-container">
      {/* <span className="home-link"></span> */}
      <ToastContainer theme="colored" autoClose={3000} />

      <Header />
      {user !== null ? (
        <>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            marginBottom="4rem"
          >
            <RootPaper elevation={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3.8} style={{ paddingTop: 25 }}>
                  <div className="profilePictureDiv">
                    {profilePic ? (
                      <img
                        src={profilePic}
                        alt={"Profile img"}
                        style={{
                          width: "100%",
                          height: "368px",
                          borderRadius: "1rem",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img
                        src={DefaultDP}
                        alt={"Profile img"}
                        style={{
                          width: "100%",
                          height: "368px",
                          borderRadius: "1rem",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </div>{" "}
                  <ProfilePhotoUploader />
                </Grid>
                <Grid item xs={12} md={8.2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.firstName}
                      </Typography>
                      <TextField
                        name="firstName"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData?.firstName}
                        // onChange={(e) => setFirstName(e.target.value)}
                        placeholder={profileData?.firstName}
                        onChange={handleChange}
                        disabled={!isEditing}
                        className="nameProfile"
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing && !isNameValid(addProfileData?.firstName)
                        }
                        helperText={
                          isEditing && !isNameValid(addProfileData?.firstName)
                            ? textProperties.userDetails.invalidFirstName
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.lastName}
                      </Typography>
                      <TextField
                        name="lastName"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData?.lastName}
                        onChange={handleChange}
                        disabled={!isEditing}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing && !isNameValid(addProfileData?.lastName)
                        }
                        helperText={
                          isEditing && !isNameValid(addProfileData?.lastName)
                            ? textProperties.userDetails.invalidLastName
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.email}
                      </Typography>
                      <TextField
                        name="email"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData?.email}
                        onChange={handleChange}
                        disabled={true}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing && !isEmailValid(addProfileData?.email)
                        }
                        helperText={
                          isEditing && !isEmailValid(addProfileData?.email)
                            ? textProperties.userDetails.invalidEmail
                            : ""
                        }
                      />
                      {user ? (
                        !user.emailVerified ? (
                          // <Button
                          //   className="verifyUser"
                          //   onClick={handleEmailVerificationClick}
                          // >
                          //   {textProperties.verifyEmail}
                          // </Button>
                          <>
                            <span>
                              {verificationEmailSent ? (
                                <span className="unverifiedTextSent">Sent</span>
                              ) : (
                                <span
                                  className="unverifiedText"
                                  onClick={handleEmailVerificationClick}
                                >
                                  {" "}
                                  Verify
                                </span>
                              )}
                            </span>
                          </>
                        ) : (
                          <>
                            <span className="verifiedEmailText">
                              {textProperties.verified}
                            </span>
                            <VerifiedIcon className="verifiedEmailIcon" />
                          </>
                        )
                      ) : null}
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.mobileNumber}
                      </Typography>
                      <TextField
                        name="mobileNumber"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData?.mobileNumber}
                        onChange={handleChange}
                        disabled={!isEditing}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing &&
                          !isMobileNumberValid(addProfileData?.mobileNumber)
                        }
                        helperText={
                          isEditing &&
                          !isMobileNumberValid(addProfileData?.mobileNumber)
                            ? textProperties.userDetails.invalidMobile
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.companyName}
                      </Typography>
                      <TextField
                        name="companyName"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData?.companyName}
                        onChange={handleChange}
                        disabled={!isEditing}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing && addProfileData?.companyName.trim() === ""
                        }
                        helperText={
                          isEditing && addProfileData?.companyName.trim() === ""
                            ? textProperties.userDetails.invalidBlankField
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.phoneNumber}
                      </Typography>
                      <TextField
                        name="phoneNumber"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData?.phoneNumber}
                        onChange={handleChange}
                        disabled={!isEditing}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          // isEditing && !isNumber(addProfileData?.phoneNumber)
                          isEditing &&
                          !isValidIndianPhoneNumber(addProfileData?.phoneNumber)
                        }
                        helperText={
                          isEditing &&
                          !isValidIndianPhoneNumber(addProfileData?.phoneNumber)
                            ? textProperties.userDetails.invalidNumber
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.companyEmail}
                      </Typography>
                      <TextField
                        name="companyEmail"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData?.companyEmail}
                        onChange={handleChange}
                        disabled={!isEditing}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing &&
                          !isCompanyEmailValid(addProfileData?.companyEmail)
                        }
                        helperText={
                          isEditing &&
                          !isCompanyEmailValid(addProfileData?.companyEmail)
                            ? textProperties.userDetails.invalidCompanyEmail
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.panNumber}
                      </Typography>
                      <TextField
                        name="panNumber"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData.panNumber}
                        onChange={handleChange}
                        // placeholder={profileData.panNumber}
                        disabled={!isEditing}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing &&
                          !isPanNumberValid(addProfileData?.panNumber)
                        }
                        helperText={
                          isEditing &&
                          !isPanNumberValid(addProfileData?.panNumber)
                            ? textProperties.userDetails.invalidPAN
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.gstNumber}
                      </Typography>
                      <TextField
                        name="gstNumber"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData.gstNumber}
                        onChange={handleChange}
                        // placeholder={profileData.gstNumber}
                        disabled={!isEditing}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={
                          isEditing &&
                          !isGSTNumberValid(addProfileData?.gstNumber)
                        }
                        helperText={
                          isEditing &&
                          !isGSTNumberValid(addProfileData?.gstNumber)
                            ? textProperties.userDetails.invalidGST
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} style={{ paddingTop: 1 }}>
                      <Typography variant="h6" className="profileH6">
                        {textProperties.role}
                      </Typography>
                      <TextField
                        name="role"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        value={addProfileData.role.toUpperCase()}
                        onChange={handleChange}
                        // placeholder={profileData.role.toUpperCase()}
                        disabled={true}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        error={isEditing && addProfileData?.role.trim() === ""}
                        helperText={
                          isEditing && addProfileData?.role.trim() === ""
                            ? "Required"
                            : ""
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={12.4} style={{ paddingTop: 1 }}>
                    <Typography variant="h6" className="profileH6">
                      {textProperties.companyAddress}
                    </Typography>
                    <TextField
                      name="companyAddress"
                      variant="outlined"
                      required
                      fullWidth
                      size="small"
                      value={addProfileData?.companyAddress}
                      onChange={handleChange}
                      disabled={!isEditing}
                      InputProps={{
                        style: {
                          borderRadius: "10px",
                          // color: "white",
                        },
                      }}
                      error={
                        isEditing &&
                        addProfileData?.companyAddress.trim() === ""
                      }
                      helperText={
                        isEditing &&
                        addProfileData?.companyAddress.trim() === ""
                          ? textProperties.userDetails.invalidBlankField
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} mt={-2} fullWidth>
                  {!isEditing ? (
                    <EditButton
                      className="profile-btn"
                      variant="contained"
                      fullWidth
                      onClick={handleEditClick}
                    >
                      {textProperties.editProfile}
                    </EditButton>
                  ) : (
                    <>
                      {showPasswordChange ? (
                        <>
                          {/* <Typography variant="h6" className="profileH6">
                        Send email to set new password
                      </Typography>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        type="password"
                      /> */}
                          {/* <Typography variant="h6" className="profileH6">
                        New Password
                      </Typography>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        type="password"
                      />
                      <Typography variant="h6" className="profileH6">
                        Retype New Password
                      </Typography>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        type="password"
                      /> */}
                          {/* <Button
                        variant="contained"
                        className="profile-btn"
                        fullWidth
                        style={{ margin: "1rem 0 0 0" }}
                        onClick={emailPasswordResetCall}
                      >
                        Change Password
                      </Button> */}
                        </>
                      ) : (
                        <>
                          <Button
                            variant="contained"
                            className="profile-btn"
                            fullWidth
                            onClick={emailPasswordResetCall}
                          >
                            {textProperties.resetPassword}
                          </Button>
                        </>
                      )}
                      <Button
                        variant="contained"
                        className="profile-btn"
                        fullWidth
                        style={{ margin: "1rem 0" }}
                        onClick={handleSaveChanges}
                      >
                        {textProperties.saveChanges}
                      </Button>
                    </>
                  )}
                </Grid>
              </Grid>
            </RootPaper>
          </Box>
        </>
      ) : (
        <GuestUserPage message={textProperties.guestMessage} />
      )}
      <Footer />
    </div>
  );
};
export default ProfilePage;
